import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { MiniSparkline } from './ChartComponents';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { STATUS } from '../lib/theme';

export function StatsCard({
  title,
  value,
  description,
  icon: Icon,
  status = 'primary',
  trend,
  trendData,
}) {
  const colors = STATUS[status] || STATUS.primary;

  const getTrendIcon = () => {
    if (!trend) return null;
    if (trend > 0) return <TrendingUp className="h-3.5 w-3.5" style={{ color: STATUS.valid.icon }} />;
    if (trend < 0) return <TrendingDown className="h-3.5 w-3.5" style={{ color: STATUS.critical.icon }} />;
    return <Minus className="h-3.5 w-3.5 text-muted-foreground" />;
  };

  const getTrendText = () => {
    if (!trend) return null;
    const trendColor = trend > 0 ? STATUS.valid.text : trend < 0 ? STATUS.critical.text : undefined;
    const trendSign = trend > 0 ? '+' : '';
    return (
      <span className="text-xs font-medium" style={{ color: trendColor }}>
        {trendSign}{trend}
      </span>
    );
  };

  return (
    <Card className="transition-shadow hover:shadow-md">
      <CardHeader className="flex flex-row items-center justify-between pb-2 space-y-0">
        <CardTitle className="text-xs font-medium text-muted-foreground">
          {title}
        </CardTitle>
        <div className="p-1.5 rounded-sm" style={{ background: colors.bg, color: colors.icon }}>
          <Icon className="h-4 w-4" />
        </div>
      </CardHeader>
      <CardContent className="space-y-2">
        <div className="flex items-baseline gap-2">
          <div className="text-2xl font-bold">
            {value}
          </div>
          {trend !== undefined && (
            <div className="flex items-center gap-1">
              {getTrendIcon()}
              {getTrendText()}
            </div>
          )}
        </div>

        <p className="text-xs text-muted-foreground">
          {description}
        </p>

        {/* Mini sparkline chart */}
        {trendData && trendData.length > 0 && (
          <div className="pt-2 -mx-2">
            <MiniSparkline
              data={trendData}
              color={colors.icon}
              height={36}
            />
          </div>
        )}
      </CardContent>
    </Card>
  );
}